import { defineMessages } from 'react-intl';

export default defineMessages({
	voiceDictationButtonLabel: {
		id: 'rovo-chat.voice-dictation.label',
		defaultMessage: 'Dictation',
		description: 'Label for the voice dictation button in the chat input',
	},
} as const);
